/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 希望支払方法 (0:車内支払, 1:ネット決済, 2:ApplePay, 3:S.RIDE Biz, 4:CABカードモバイル決済, 5:PayPay, 6:auPAY, 7:d払い, 8:楽天ペイ, 9:汎用ＱRコード決済)
 * @export
 * @enum {number}
 */
export enum DesiredPaymentMethodEnum {
    /** 車内支払 */
    IN_CAR = '0',
    /** ネット決済 */
    ONLINE = '1',
    /** ApplePay */
    APPLE_PAY = '2',
    /** S.RIDE Biz */
    SRIDE_BIZ = '3',
    /** CABカードモバイル決済 */
    CAB_CARD_MOBILE = '4',
    /** PayPay */
    PAYPAY = '5',
    /** auPAY */
    AU_PAY = '6',
    /** d払い */
    D_BARAI = '7',
    /** 楽天ペイ */
    RAKUTEN_PAY = '8',
    /** 汎用ＱRコード決済 */
    QR_CODE = '9',
    /** DiDi */
    DIDI = '14',
    /** Uber */
    UBER = '15'
}

/**
 * 希望支払方法 (0:車内支払, 1:ネット決済, 2:ApplePay, 3:S.RIDE Biz, 4:CABカードモバイル決済, 5:PayPay, 6:auPAY, 7:d払い, 8:楽天ペイ, 9:汎用ＱRコード決済) の Union 型
 * @export
 * @typedef DesiredPaymentMethod
 */
export type DesiredPaymentMethod =
  typeof DesiredPaymentMethodEnum[keyof typeof DesiredPaymentMethodEnum];

/**
 * 希望支払方法 (0:車内支払, 1:ネット決済, 2:ApplePay, 3:S.RIDE Biz, 4:CABカードモバイル決済, 5:PayPay, 6:auPAY, 7:d払い, 8:楽天ペイ, 9:汎用ＱRコード決済) のラベルマップ
 * @export
 */
export const DesiredPaymentMethodLabels = {
    /**
     * 数値キー: DesiredPaymentMethodEnum.IN_CAR
     * 名前キー:  IN_CAR
     */
    [DesiredPaymentMethodEnum.IN_CAR]: '車内支払',
    IN_CAR:                             '車内支払',
    /**
     * 数値キー: DesiredPaymentMethodEnum.ONLINE
     * 名前キー:  ONLINE
     */
    [DesiredPaymentMethodEnum.ONLINE]: 'ネット決済',
    ONLINE:                             'ネット決済',
    /**
     * 数値キー: DesiredPaymentMethodEnum.APPLE_PAY
     * 名前キー:  APPLE_PAY
     */
    [DesiredPaymentMethodEnum.APPLE_PAY]: 'ApplePay',
    APPLE_PAY:                             'ApplePay',
    /**
     * 数値キー: DesiredPaymentMethodEnum.SRIDE_BIZ
     * 名前キー:  SRIDE_BIZ
     */
    [DesiredPaymentMethodEnum.SRIDE_BIZ]: 'S.RIDE Biz',
    SRIDE_BIZ:                             'S.RIDE Biz',
    /**
     * 数値キー: DesiredPaymentMethodEnum.CAB_CARD_MOBILE
     * 名前キー:  CAB_CARD_MOBILE
     */
    [DesiredPaymentMethodEnum.CAB_CARD_MOBILE]: 'CABカードモバイル決済',
    CAB_CARD_MOBILE:                             'CABカードモバイル決済',
    /**
     * 数値キー: DesiredPaymentMethodEnum.PAYPAY
     * 名前キー:  PAYPAY
     */
    [DesiredPaymentMethodEnum.PAYPAY]: 'PayPay',
    PAYPAY:                             'PayPay',
    /**
     * 数値キー: DesiredPaymentMethodEnum.AU_PAY
     * 名前キー:  AU_PAY
     */
    [DesiredPaymentMethodEnum.AU_PAY]: 'auPAY',
    AU_PAY:                             'auPAY',
    /**
     * 数値キー: DesiredPaymentMethodEnum.D_BARAI
     * 名前キー:  D_BARAI
     */
    [DesiredPaymentMethodEnum.D_BARAI]: 'd払い',
    D_BARAI:                             'd払い',
    /**
     * 数値キー: DesiredPaymentMethodEnum.RAKUTEN_PAY
     * 名前キー:  RAKUTEN_PAY
     */
    [DesiredPaymentMethodEnum.RAKUTEN_PAY]: '楽天ペイ',
    RAKUTEN_PAY:                             '楽天ペイ',
    /**
     * 数値キー: DesiredPaymentMethodEnum.QR_CODE
     * 名前キー:  QR_CODE
     */
    [DesiredPaymentMethodEnum.QR_CODE]: '汎用ＱRコード決済',
    QR_CODE:                             '汎用ＱRコード決済',
    /**
     * 数値キー: DesiredPaymentMethodEnum.DIDI
     * 名前キー:  DIDI
     */
    [DesiredPaymentMethodEnum.DIDI]: 'DiDi',
    DIDI:                             'DiDi',
    /**
     * 数値キー: DesiredPaymentMethodEnum.UBER
     * 名前キー:  UBER
     */
    [DesiredPaymentMethodEnum.UBER]: 'Uber',
    UBER:                             'Uber',
} as const;

/**
 * 希望支払方法 (0:車内支払, 1:ネット決済, 2:ApplePay, 3:S.RIDE Biz, 4:CABカードモバイル決済, 5:PayPay, 6:auPAY, 7:d払い, 8:楽天ペイ, 9:汎用ＱRコード決済) のラベル Union 型
 * @export
 * @typedef DesiredPaymentMethodLabel
 */
export type DesiredPaymentMethodLabel =
  typeof DesiredPaymentMethodLabels[keyof typeof DesiredPaymentMethodLabels];

/**
 * 希望支払方法 (0:車内支払, 1:ネット決済, 2:ApplePay, 3:S.RIDE Biz, 4:CABカードモバイル決済, 5:PayPay, 6:auPAY, 7:d払い, 8:楽天ペイ, 9:汎用ＱRコード決済) のラベル取得関数
 * @export
 * @param { DesiredPaymentMethod } value - 列挙体の値
 * @returns { DesiredPaymentMethodLabel } ラベル文字列
 */
export function getDesiredPaymentMethodLabel(
  value: DesiredPaymentMethod
): DesiredPaymentMethodLabel {
  return DesiredPaymentMethodLabels[value];
}

/**
 * 希望支払方法 (0:車内支払, 1:ネット決済, 2:ApplePay, 3:S.RIDE Biz, 4:CABカードモバイル決済, 5:PayPay, 6:auPAY, 7:d払い, 8:楽天ペイ, 9:汎用ＱRコード決済) のラベル配列を取得する関数
 * @export
 * @param { DesiredPaymentMethod[] } values - 列挙体の値配列
 * @returns { DesiredPaymentMethodLabel[] } ラベル文字列配列
 */
export function getDesiredPaymentMethodLabels(values: DesiredPaymentMethod[]): DesiredPaymentMethodLabel[] {
  return values.map((value) => getDesiredPaymentMethodLabel(value));
}

/**
 * 希望支払方法 (0:車内支払, 1:ネット決済, 2:ApplePay, 3:S.RIDE Biz, 4:CABカードモバイル決済, 5:PayPay, 6:auPAY, 7:d払い, 8:楽天ペイ, 9:汎用ＱRコード決済) のラベル配列
 * @export
 */
export const DesiredPaymentMethodLabelList = [
  '車内支払','ネット決済','ApplePay','S.RIDE Biz','CABカードモバイル決済','PayPay','auPAY','d払い','楽天ペイ','汎用ＱRコード決済','DiDi','Uber',
] as const;

